import http from '@/http'
import User from '@/store/models/User'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'organizations/:organizationId/users/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async index({ commit, rootGetters }, payload) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    const signedInUserId = rootGetters['auth/signedInUser'].id
    await http.get(apiPath + serializeObjectToQueryParameter(payload)).then(response => {
      User.insert({
        data: response.data.data.map(user => user.attributes)
                                .filter(user => user.id != signedInUserId)
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async show({ commit, rootGetters }, id) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath + id).then(response => {
      User.insert({
        data: response.data.data.attributes
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
